export default __webpack_public_path__ + "static/media/compoteAndCream.b1b42991.png";